/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CellSignalHigh(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M198.12305,28.53186a15.95339,15.95339,0,0,0-17.4375,3.46826L16.001,196.68616a15.95542,15.95542,0,0,0-4.69092,11.65869q.01319.58374.06933,1.168a16.06842,16.06842,0,0,0,8.02735,12.40771q.50536.28712,1.031.53662a16.00569,16.00569,0,0,0,6.87574,1.543H192a16.018,16.018,0,0,0,16-16V43.3136A15.95222,15.95222,0,0,0,198.12305,28.53186ZM192,208.00012l-24-.00049V67.31946L192,43.32Z" />
    </Svg>
  );
}

export default CellSignalHigh;
